import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ViaSocketIntegrationPage = () => {
  const location = useLocation();
  const { selectedApp } = location.state || {};

  useEffect(() => {
    let container = document.getElementById("viasocket-container");
    if (!container) {
      container = document.createElement("div");
      container.id = "viasocket-container";
      document.body.appendChild(container);
    }
    container.innerHTML = "";
    const script = document.createElement("script");
    script.src = "https://integrations.viasocket.com/integrations.js";
    script.id = "viasocket_integrations";
    script.crossOrigin = "anonymous";
    script.setAttribute("primaryApp", "frejun");
    script.setAttribute("appName1", selectedApp || "");
    container.appendChild(script);
    return () => {
      if (container) {
        container.remove();
      }
    };
  }, [selectedApp]);

  return ([]);
};

export default ViaSocketIntegrationPage;
